const filters = () => {
	const filter    = document.querySelector('.market-filter');
	const toggleBtn = document.querySelector('[data-filter="toggle"]');
	const applyBtn = document.querySelector('[data-filter="apply"]');
	if(!toggleBtn || !applyBtn) {
		return
	}
	toggleBtn.addEventListener('click', (event) => {
		event.stopPropagation();
		event.preventDefault();
		const input = event.target.closest('label').querySelector('input');
		input.checked = !input.checked;
		filter.classList.toggle('active');
	});
	applyBtn.addEventListener('click', (event) => {
		event.stopPropagation();
		event.preventDefault();
		toggleBtn.click();
	})
};

export default filters;
